import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PageOverview" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Introduction = _resolveComponent("Introduction")!
  const _component_ActiveDashboardsOverview = _resolveComponent("ActiveDashboardsOverview")!
  const _component_InactiveDashboardsOverview = _resolveComponent("InactiveDashboardsOverview")!
  const _component_HelpAndSupportBlock = _resolveComponent("HelpAndSupportBlock")!
  const _component_DashboardPreviewModal = _resolveComponent("DashboardPreviewModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Introduction),
    _createVNode(_component_ActiveDashboardsOverview),
    _createVNode(_component_InactiveDashboardsOverview),
    _createVNode(_component_HelpAndSupportBlock),
    (_ctx.isDashboardPreviewModalActive)
      ? (_openBlock(), _createBlock(_component_DashboardPreviewModal, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ]))
}